<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content"
        v-loading="loadingStaus"
        :element-loading-text="loadingText">
        <el-row :gutter="48">
          <el-form ref="openapiForm" :model="formData" :rules="rules" label-width="100px">
            <el-col :span="18" class="content-left">
              <el-form-item label="APPID" prop="name">
                <el-input v-model="formData.id" placeholder="此处信息不填，系统自动生成" :disabled="appDisabled"></el-input>
              </el-form-item>
              <el-form-item label="APPSECRET">
                <el-input v-model="formData.secret" :disabled="appDisabled" placeholder="此处信息不填，系统自动生成">
                  <template slot="append">
                    <el-button type="primary" v-if="!formDisabled" @click="randSecret" icon="el-icon-refresh-right">
                      生成SECRET
                    </el-button>
                  </template>
                </el-input>
              </el-form-item>
               <el-form-item label="公司简介">
                <el-input type="textarea" v-model="formData.remark"></el-input>
              </el-form-item>
              <el-form-item label="充值回调地址" prop="notify_url">
                <el-input v-model="formData.notify_url"></el-input>
              </el-form-item>
              <el-form-item label="白名单" prop="ip_whitelist">
                <el-input type="textarea" :rows="8" v-model="formData.ip_whitelist"></el-input>
              </el-form-item>
              <el-form-item label="开启的权限" prop="openapi_server">
                <el-input type="textarea" :rows="8" v-model="formData.openapi_server"></el-input>
              </el-form-item>
            </el-col>
            <el-col class="content-right" :span="6">
              <!-- <el-form-item label="附件" prop="attachment">
                <ApeUploader :limit="1" :isImage="false" :allowSize="1024*1024*500" :allowTypeList="attachmentType" @handleUploadSuccess="handleAttachmentUploadSuccess" @handleUploadRemove="handleAttachmentUploadRemove" :upload-file-list="attachmentUploadFileList"></ApeUploader>
              </el-form-item> -->
              <el-form-item label="是否启用白名单" prop="is_restriction" size="small">
                <el-radio-group v-model="formData.is_restriction">
                  <el-radio-button label="1">启用</el-radio-button>
                  <el-radio-button label="0">停用</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="配置状态" prop="status" size="small">
                <el-radio-group v-model="formData.status">
                  <el-radio-button label="1">启用</el-radio-button>
                  <el-radio-button label="0">停用</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <div class="right-button">
                <el-button size="medium" type="primary"  :disabled="formDisabled" @click="saveConfirm">保存</el-button>
                <el-button size="medium" @click="returnList">返回</el-button>
              </div>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </PageHeaderLayout>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeUploader from '@/components/ApeUploader'
import ApeEditor from '@/components/ApeEditor'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeUploader,
    ApeEditor,
  },
  data() {
    return {
      activeTab: '0',
      hearTitle: '基本设置',
      loadingStaus: true,
      loadingText: '正在提交中……',
      formDisabled: false,
      appDisabled: true,
      openapiId:0, // 公司id，0表示创建，非零为编辑
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      // 分类列表
      categoryList:[],
      // 标签
      categoryLabelList:[],
      // 已选中的分类列表，用于cascader组件选中效果
      selectedList:[],
      // 已选中标签
      selectedLabelList:[],
      // 公司基本信息表单结构
      formData:{
        secret: this.$utils.randomString(16),
        status: 1,
        is_restriction: 1,
      },
      // 已上传图片列表
      uploadFileList:[],
      // 公司基本信息规则
      rules: {
        remark: [
          {required: true, message: '输入公司名称', trigger: 'blur' },
        ]
      },
      // 附件类型
      attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
      // 已上传附件列表
      attachmentUploadFileList:[],
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
  },
  methods: {
    // 生成SECRET
    randSecret(e) {
      let secret = this.$utils.randomString(16)
      this.formData.secret = secret
      console.log('secret -> ', secret)
      // e.target.form.secret = "1111111111"
      console.log('formData -> ', this.formData)
      console.log('e -> ', e)
    },
    // 返回列表
    returnList() {
      this.$router.push('/openapi')
    },
    // 菜单选择
    categoryChange(v) {
      console.log("categoryChange", v)
      if (v) {
        this.formData.parent_id = v
      }
    },
    // 级联菜单组件change事件
    cascaderLabelChange(v) {
      if (v.length) {
        this.formData.category_2_id = v[(v.length-1)]
        this.formData.category_2_ids = v
      } else {
         this.formData.category_2_id = ''
         this.formData.category_2_ids = []
      }
    },
    // 级联菜单自定义验证，选择分类
    cascaderVerify(rule, value, callback) {
      if (rule.required && !this.selectedList.length) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs['openapiForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      return true
    },
    // 公司相关信息的保存处理
    async formSubmit() {
      this.loadingStaus = true
      console.log("formData -> ", this.formData);
      let id = await this.$api.saveOpenapi(this.formData)
      if (id) {
        this.$notify.success('保存成功！')
      }

      if (this.openapiId === 0 && id) {
        // this.$router.push(this.$route.matched[1].path+'/'+id+'/edit')
        this.$router.push(this.$route.matched[1].path)
        // this.initopenapiForm()
      }
      this.$nextTick(() => {
        this.loadingStaus = false
      })
    },
    // 图片上传成功回调
    handleUploadSuccess(file, fileList) {
      this.formData.cover = file.id
      this.uploadFileList = fileList
    },
    // 图片删除回调
    handleUploadRemove(file, fileList) {
      this.formData.cover = 0
      this.uploadFileList = fileList
    },
    // 附件上传成功回调
    handleAttachmentUploadSuccess(file, fileList) {
      this.formData.attachment = file.id
      this.attachmentUploadFileList = fileList
    },
    // 附件删除回调
    handleAttachmentUploadRemove(file, fileList) {
      this.formData.attachment = 0
      this.attachmentUploadFileList = fileList
    },
    // 图片上传自定义验证
    apeUploaderVerify(rule, value, callback) {
      if (rule.required && !this.formData.cover) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 处理编辑器内容输入
    handleTinymceInput(val) {
      this.formData.content = val
    },
    // 初始化公司基本信息
    async initOpenapiForm() {
      let url = this.$route.path
      let urlSlashCount=url.split('/').length
      this.action = url.split('/')[urlSlashCount-1].toLowerCase()
      this.formDisabled = (this.action === 'view') ? true : false
      // this.appDisabled = (this.action === 'view') ? false : true
      console.log("formDisabled -> ", this.formDisabled)
      console.log("appDisabled -> ", this.appDisabled)
      if (this.$route.params.openapi_id) {
        this.openapiId = this.$route.params.openapi_id
      }
      if (this.openapiId) {
        let {info} = await this.$api.getOpenapiInfo(this.openapiId)
        console.log("formData", info)
        this.formData = info
      }
    },
  },
  async mounted() {
    this.loadingStaus = true
    this.initOpenapiForm()
    this.$nextTick(() => {
      this.loadingStaus = false
    })
  },
}
</script>

<style lang="stylus" scoped>
  .content-left
    min-height 640px
    border-right 1px solid  #e8e8e8
    .el-cascader
      display block
      width 320px
  .content-right
    .right-button
      border-top 1px solid #e8e8e8e8
      padding 12px 12px
    .el-form-item__label
      float none
      display inline-block
      text-align left
      padding 0 0 10px 0
    .el-form-item__content
      margin-left 0px !important
      .el-checkbox-group
        margin-top -12px
</style>
